
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import moment from 'moment';
import { SafezoneVisualizerHtmlComponent } from '../safezone-visualizer.html/safezone-visualizer.html.component';
import { ArcAngelLiveModeService } from '../../../core/services/arc-angel-live-mode.service';

@Component({
  selector: 'app-details-window-header',
  standalone: true,
  imports: [SafezoneVisualizerHtmlComponent],
  templateUrl: './details-window-header.component.html',
  styleUrl: './details-window-header.component.css'
})

export class DetailsWindowHeaderComponent implements OnInit, OnDestroy {
  @Input() mapEntity: any;
  @Input() tempLat: number = 0.0;
  @Input() tempLong: number = 0.0;
  @Output() close = new EventEmitter<void>();

  icon: string = 'assets/img/default_entity.png';
  liveIncident: any;

  constructor(
    private arcAngelLiveModeService: ArcAngelLiveModeService
  ){

  }

  ngOnInit() {
    if (this.mapEntity && typeof this.mapEntity.iconUrl === 'string') {
      this.icon = this.mapEntity.iconUrl;
    }else if(this.mapEntity.icon){
      this.icon = this.mapEntity.icon;    
    } 
    this.liveIncident = this.arcAngelLiveModeService.data.liveIncident || '';
  }

  formatDate(value: any): string {
    const fmt = 'MMMM Do YYYY, h:mm:ss a';
    if (value === null || value === undefined || value === '') {
      return moment().format(fmt);
    }
    const m = moment(value);
    return m.isValid() ? m.format(fmt) : moment().format(fmt);
  }

  isEmpty(value: any): boolean {
    return value === '' || value === null || value === undefined;
  }

  round(value: any): number | string {
    if (value === undefined || value === null || isNaN(value)) return '';
    return Math.round(parseFloat(value) * 1000000) / 1000000;
  }

  showStaticCoordinates(): boolean {
    return !!(this.mapEntity?.latitude && this.mapEntity?.longitude);
  }

  showTemporalCoordinates(): boolean {
    // If you have a UnitMapEntity class, use instanceof; otherwise, adapt as needed
    return this.mapEntity?.type === 'UnitMapEntity';
  }

  closeWindow() {
    this.close.emit(); // <-- Emit the close event
  }
  ngOnDestroy() {
    // Clean up any listeners if you add them
  }
}